import { cn } from "../../utils/cn";
import { Icon } from "@iconify/react";

export const FeatureCard = ({
    title,
    description,
    icon,
    className,
    iconClass,
}) => {
    const isImagePath =
        icon && typeof icon === "string" && icon.startsWith("/");

    return (
        <div
            className={cn(
                "flex flex-row justify-start items-start gap-4 p-6 rounded-lg",
                className,
            )}
        >
            <div
                className={cn(
                    "shrink-0 flex items-center justify-center rounded-full",
                    iconClass,
                )}
                style={{ width: 50, height: 50, backgroundColor: "#DBF5FF" }}
            >
                {isImagePath ? (
                    <img
                        src={icon}
                        alt={title}
                        style={{ width: 24, height: 24 }}
                        className="object-contain"
                    />
                ) : (
                    <Icon
                        icon={icon}
                        style={{ width: 24, height: 24 }}
                        className="text-primary-500"
                    />
                )}
            </div>

            <div>
                <h6 className="text-md text-title dark:text-white font-medium">
                    {title}
                </h6>
                <p className="text-sm text-muted dark:text-base-400 mt-0.5">
                    {description}
                </p>
            </div>
        </div>
    );
};
